import { createSlice } from "@reduxjs/toolkit";

const clienstSlice = createSlice({
  name: "clients",
  initialState: {
    list: [],
  },
  reducers: {
    setClients(state, action) { state.list = action.payload },
    setClient(state, action) { state.list.push(JSON.parse(action.payload)) }
  },
});

export const { setClients, setClient } = clienstSlice.actions;
export default clienstSlice.reducer;
